module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [(_vm.items.length > 24) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  })], 2) : _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v("已经是最后一页了！")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('Pagination', {
    attrs: {
      "hasMore": _vm.items.length > 24
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b673354!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ItemList.vue
// module id = 283
// module chunks = 6